import { render, staticRenderFns } from "./AddReborer.vue?vue&type=template&id=567de5c4&scoped=true"
import script from "./AddReborer.vue?vue&type=script&lang=js"
export * from "./AddReborer.vue?vue&type=script&lang=js"
import style0 from "./AddReborer.vue?vue&type=style&index=0&id=567de5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567de5c4",
  null
  
)

export default component.exports